/**
 * YouTube Video Embed Component
 * Reusable component for embedding Dr. Reddy's YouTube videos
 */

import React from 'react';
import { Play } from 'lucide-react';

// Dr. Reddy's YouTube Videos
export const DR_REDDY_VIDEOS = {
  rotatorCuff: {
    id: '1UY7HfGRBhY',
    title: 'Rotator Cuff Repair: A Surgeon\'s Guide to Shoulder Recovery',
    description: 'Expert walkthrough of rotator cuff repair procedure, anatomy, and recovery'
  },
  orthopedicScience: {
    id: 'PnTSKZaeKtY',
    title: 'From Carpentry to Precision: The Real Science Behind Orthopedics',
    description: 'Understanding the precision and science in modern orthopedic surgery'
  },
  commonMistakes: {
    id: 'zImeNCQdTKw',
    title: 'STOP Making These Common Mistakes in Orthopedic Upper Limb Care',
    description: 'Learn what mistakes to avoid for better shoulder and arm health'
  },
  aboutDrReddy: {
    id: 'taqLAlV0kBM',
    title: 'Dr. Deepthi Nandan Reddy - Orthopedic Upper Limb Specialist',
    description: 'Meet Dr. Reddy and learn about his expertise and approach'
  },
  preventInjuries: {
    id: 'dB_okKsQmM8',
    title: 'How to Prevent Orthopedic Injuries',
    description: 'Tips from Dr. Reddy on preventing shoulder and upper limb injuries'
  }
};

export const YouTubeEmbed = ({ videoId, title, className = '' }) => {
  return (
    <div className={`relative w-full aspect-video rounded-xl overflow-hidden shadow-lg ${className}`}>
      <iframe
        src={`https://www.youtube.com/embed/${videoId}`}
        title={title || 'Video'}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        className="absolute inset-0 w-full h-full"
      />
    </div>
  );
};

export const VideoSection = ({ video, theme }) => {
  if (!video) return null;
  
  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <div className="flex items-center gap-3 mb-6">
            <Play className="w-8 h-8" style={{ color: theme?.primaryHex || '#3b82f6' }} />
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900">
              Watch: Expert Insights
            </h2>
          </div>
          <p className="text-gray-600 mb-6">{video.description}</p>
          <YouTubeEmbed videoId={video.id} title={video.title} />
          <p className="text-sm text-gray-500 mt-4 text-center">
            {video.title} - Dr. Deepthi Nandan Reddy
          </p>
        </div>
      </div>
    </section>
  );
};

export default YouTubeEmbed;
